import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
  mailNotifyTemplates:state => state.mailNotifyTemplates,
  mnRoutesList:state => state.mnRoutesList,
};
